/* eslint-disable camelcase */

export default class PracticeMapping {
  /**
   * Practice Mapping entity for mapping PG Practice to PO Practice
   * @param {Boolean} [enabled=false]
   * @param {number} kareo_customer_id
   * @param {number} kareo_practice_id
   * @param {string} practiceUuid
   */
  constructor ({ enabled = false, kareo_customer_id, kareo_practice_id, practiceUuid }) {
    this.enabled = enabled
    this.practiceUuid = practiceUuid
    this.practiceKey = `k_${kareo_practice_id}_${kareo_customer_id}`
  }
}
